var LOGOUT_URLS_KEY = 'ecommerceLogoutUrls';
var storeEcommerceLogoutUrl = function storeEcommerceLogoutUrl(url) {
  try {
    var baseUrl = new URL(url);
    if (baseUrl.protocol !== 'https:') {
      return;
    }
    var storedData = sessionStorage.getItem(LOGOUT_URLS_KEY) || '[]';
    var setData = new Set(JSON.parse(storedData));
    var ecommerceLogoutUrl = "".concat(baseUrl.origin, "/customer/account/logout?appKey=mypages");
    setData.add(ecommerceLogoutUrl);
    sessionStorage.setItem(LOGOUT_URLS_KEY, JSON.stringify(Array.from(setData)));
  } catch (_unused) {
    // Reset data if something has gone wrong.
    sessionStorage.removeItem(LOGOUT_URLS_KEY);
  }
};
var popEcommerceLogoutUrl = function popEcommerceLogoutUrl() {
  try {
    var storedData = JSON.parse(sessionStorage.getItem(LOGOUT_URLS_KEY) || '[]');
    if (storedData.length) {
      var url = storedData.pop();
      var setData = new Set(storedData);
      if (setData.size) {
        sessionStorage.setItem(LOGOUT_URLS_KEY, JSON.stringify(Array.from(setData)));
      } else {
        sessionStorage.removeItem(LOGOUT_URLS_KEY);
      }
      return url;
    }
    return null;
  } catch (_unused2) {
    // Reset data if something has gone wrong.
    sessionStorage.removeItem(LOGOUT_URLS_KEY);
    return null;
  }
};

export { popEcommerceLogoutUrl, storeEcommerceLogoutUrl };
